export default __webpack_public_path__ + "static/media/map-pin.71c686e5.svg";